// Global SVG filter — real duotone (dark→cobalt, light→cream)
export default function DuotoneFilter() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
      <defs>
        {/* Cobalt duotone: maps grayscale luminance into cobalt→cream */}
        <filter id="duotone-cobalt" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="0.299 0.587 0.114 0 0
                    0.299 0.587 0.114 0 0
                    0.299 0.587 0.114 0 0
                    0 0 0 1 0"
          />
          <feComponentTransfer>
            {/* cobalt #1F3A6E → cream #F5EBD8 */}
            <feFuncR tableValues="0.122 0.961" />
            <feFuncG tableValues="0.227 0.922" />
            <feFuncB tableValues="0.431 0.847" />
          </feComponentTransfer>
        </filter>
      </defs>
    </svg>
  );
}
